import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { utils, write } from "xlsx";
import Papa from "papaparse";
import moment from "moment";

import { DropDownField, TextInputField, CalendarField, MultiSelectField } from "../../../helpers";
import Button from "../../../helpers/Button";
import { Menu } from 'primereact/menu';

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchVendorPaymentsCashFlow, updateSearchOptions, updateSearchParams, updateVendorPaymentCashFlowData } from "../../../services/redux/reducers/cashFlow/cashFlow";
import { searchVendorPayments } from "../../../services/api/vendorPayment";

import { getAddFilterOptions, getDateRange, getMatchedRegexPattern, normalizeLabel } from "../../../utils";
import DateFilter from "../../../common/DateFilter";


const vpCreditNonCreditConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Vendor Payments Data', value: 'vendorPaymentsData' }
        ]
    },
    {
        srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
    },
    {
        srNO: 2,
        static: true,
        type: "SEARCH_BY",
        name: "searchBy",
        label: "Search by",
        options: [
            { label: 'No Filters', value: 'all' },
            { label: 'Vendor Payment No.', value: 'vendorPaymentDocNo' },
            { label: 'Seller PO No.', value: 'sellerPODocNo' },
            { label: 'seller PI No', value: 'sellerPINumber' },
            { label: 'seller PI Doc No.', value: 'sellerPIDocNo' },
            { label: 'Company Name', value: 'companyName' },
            { label: 'User Name', value: 'userName' },
        ]
    },
    {
        srNO: 3,
        static: true,
        type: "SELECT",
        name: "branchId",
        label: "Branch",
    },
    {
        srNO: 5,
        static: false,
        type: "SELECT",
        name: "paymentMode",
        label: "Payment Mode",
        options: [
            { label: 'ONLINE', value: 'ONLINE' },
            { label: 'CHEQUE', value: 'CHEQUE' },
            { label: 'CREDIT', value: 'CREDIT' },
            { label: 'BANK TRANSFER', value: 'BANK TRANSFER' }
        ]
    },
    {
        srNO: 6,
        static: false,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' },
            { label: 'Payment Date', value: 'paymentDate' }
        ]
    },
    {
        srNO: 7,
        static: false,
        type: "SELECT",
        name: "budgetMode",
        label: "Budget Mode",
        options: [
            { label: 'Included', value: 'Included' },
            { label: 'Not Included', value: 'Not Included' }
        ]
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "vendorPaymentDocNo",
        label: "Vendor Payment No.",
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "chequeNo",
        label: "Cheque No.",
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPODocNo",
        label: "Seller PO No.",
    },
    {
        srNO: 13,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPINumber",
        label: "Seller PI No.",
    },
    {
        srNO: 14,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "sellerPIDocNo",
        label: "seller PI Doc No.",
    },
    {
        srNO: 16,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "userName",
        label: "User Name",
    },
    {
        srNO: 17,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "companyName",
        label: "Company Name",
    },

]

const Search = (props) => {
    const [searchConfig, setSearchConfig] = useState(vpCreditNonCreditConfig)

    const searchParams = useSelector(state => state.vendorPaymentsCashFlow.searchParams)
    const paginationParams = useSelector(state => state.vendorPaymentsCashFlow.paginationParams)
    const searchOptions = useSelector(state => state.vendorPaymentsCashFlow.searchOptions)
    const userDetails = useSelector(state => state.userDetails)
    const companyBranches = userDetails?.PMCompanyDetails?.companyBranches

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)

    const dispatch = useDispatch()

    const statusList = useSelector((state) => state.common.status)

    useEffect(() => {
        const loggedInUserRole = userDetails.rolesList.find(eachRole => eachRole.userRoleId === userDetails.activeRoleId)

        if (searchOptions.length === 0) {
            let filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)

            filteredSearchOptions = filteredSearchOptions.map(eachSearchOption => {
                if (eachSearchOption.name === "branchId") {
                    const updatedCompanyBranches = companyBranches?.map(eachCompanyBranch => ({ ...eachCompanyBranch, label: eachCompanyBranch.branchName, value: eachCompanyBranch.branchId }))
                    if (loggedInUserRole.branchId) {
                        const relatedCompanyBranch = companyBranches.find(eachCompanyBranch => eachCompanyBranch.branchId === loggedInUserRole.branchId)
                        eachSearchOption.options = [{ ...relatedCompanyBranch, label: relatedCompanyBranch.branchName, value: relatedCompanyBranch.branchId }]
                        dispatch(updateSearchParams({ ...searchParams, branchId: relatedCompanyBranch.branchId }))
                    } else {
                        eachSearchOption.options = updatedCompanyBranches
                    }
                }
                return eachSearchOption
            })

            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    const addFilterOption = (srNO) => {
        const relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)

        if (relatedConfig.name === "branchId") {
            const updatedCompanyBranches = companyBranches?.map(eachCompanyBranch => ({ ...eachCompanyBranch, label: eachCompanyBranch.branchName, value: eachCompanyBranch.branchId }))
            relatedConfig.options = updatedCompanyBranches
        }
        dispatch(updateSearchOptions([...searchOptions, relatedConfig]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = { ...searchParams }

        if (relatedSearchOption.type === "SEARCH_BY") {
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "DATE") {
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            console.log("updateSearchParams", updatedSearchParams)
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "SELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value

        const updatedSearchParams = { ...searchParams, [event.target.name]: event.target.value }
        if (event.target.name === "branchId") {
            dispatch(updateVendorPaymentCashFlowData([]))
        }

        if (event.target.name === "searchText") {
            const availableOptions = [...vpCreditNonCreditConfig]
            const matchText = eventValue.split(";")[0]
            const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
            updatedSearchParams.searchBy = matchedPattern
        }

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }
        
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const handleSearch = () => {

        let errorFound = false

        searchOptions.map(eachOption => {
            if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
                const errorMsgText = normalizeLabel(searchParams.searchBy)

                dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: "Please enter search text" }))
                errorFound = true
            }

            if (eachOption.type === "TEXT" || eachOption.type === "SELECT") {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)

                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                }
            }
        })

        if (searchParams.searchText && searchParams.searchBy === "all") {
            return dispatch(raiseToast({ severity: 'error', detail: `Please enter filter!` }))
        }

        const updatedSearchParams = { ...searchParams }

        if (updatedSearchParams.searchBy !== "all") {
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }
        const vendorPaymentParams = {
            ...paginationParams,
            ...updatedSearchParams,
            pageNo: 0,
            isCashflowReq: true,
            paginator: true
        }
        if (searchParams.dateType === "paymentDate") {
            vendorPaymentParams.sortBy = "paymentDate"
        }
        if (!searchParams.branchId) {
            return dispatch(raiseToast({ severity: 'error', detail: "Please select branch", life: 3000 }))
        }

        if (!errorFound) {
            dispatch(fetchVendorPaymentsCashFlow(vendorPaymentParams))
        }
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadVPDataForVendorPayment("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadVPDataForVendorPayment("CSV")
        }
    ]

    const downloadVPDataForVendorPayment = async (dataFormat) => {

        const vendorPaymentSearchParams = {
            ...searchParams,
            isCashflowReq: true,
            limitedPagination: false,
            paginator: false
        }

        const vendorPaymentResponse = await searchVendorPayments(vendorPaymentSearchParams)

        if (vendorPaymentResponse.failure) {
            dispatch(raiseToast({ severity: 'error', detail: vendorPaymentResponse.data.error }))
        } else {
            const vendorPaymentsNonCreditData = vendorPaymentResponse.data.data

            const downloadData = []
            vendorPaymentsNonCreditData.map(eachVendorPayment => {
                let sellerName = ""
                if (eachVendorPayment["sellerPO.seller.firstName"]) {
                    sellerName = eachVendorPayment["sellerPO.seller.firstName"]
                }
                if (eachVendorPayment["sellerPO.seller.lastName"]) {
                    sellerName = eachVendorPayment["sellerPO.seller.lastName"]
                }

                let approvedByUser = ""
                if (eachVendorPayment["approvedVendorUsers.firstName"]) {
                    approvedByUser += eachVendorPayment["approvedVendorUsers.firstName"]
                }
                if (eachVendorPayment["approvedVendorUsers.lastName"]) {
                    approvedByUser += " " + eachVendorPayment["approvedVendorUsers.lastName"]
                }

                const relatedStatus = statusList?.find(eachStatus => eachStatus.statusId === eachVendorPayment?.statusId)

                const obj = {
                    "Payment No": eachVendorPayment["docNo"],
                    "Seller PO No": eachVendorPayment?.["sellerPO.docNo"],
                    "Company": eachVendorPayment["sellerPO.companies.companyName"],
                    "Payment Date": moment(eachVendorPayment.paymentDate).format("DD.MM.YYYY"),
                    "KAM": eachVendorPayment["users.firstName"] + " " + eachVendorPayment["users.lastName"],
                    "Amount": eachVendorPayment["amount"],
                    "Payment Mode": eachVendorPayment["paymentMode"],
                    "Include In Budget": eachVendorPayment["isIncludedInBudget"] ? "YES" : "NO",
                    "Verified By Finance": eachVendorPayment["isVerifiedByFinance"] ? "YES" : "NO",
                    "Status": relatedStatus?.status,
                    "Approved By": approvedByUser
                }
                downloadData.push(obj)
            })

            if (dataFormat === "CSV") {
                let csv = Papa.unparse(downloadData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "VP_bankdetails.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(downloadData)

                const range = utils.decode_range(ws['!ref']);
                for (let R = range.s.r; R <= range.e.r; ++R) {
                    for (let C = range.s.c; C <= range.e.c; ++C) {
                        const cellAddress = utils.encode_cell({ r: R, c: C });
                        if (ws[cellAddress] && ws[cellAddress].t === 's' && ws[cellAddress].v.charAt(0) === "'") {
                            ws[cellAddress].v = ws[cellAddress].v.substring(1);
                        }
                    }
                }

                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'VP_bankdetails.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    }

    return (
        <div className="p-card" style={{ border: "1px solid #e9ecef" }} onKeyDown={handleSearchKeyPress}>
            <div className="grid">
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_TEXT") {

                            let searchByOptions = [{ label: 'No Filters', value: 'all' }]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })

                            return (
                                <>
                                    <div className="flex flex-column col-12">
                                        <TextInputField
                                            name="searchText"
                                            labelText="Search Text"
                                            placeholder="No Filter"
                                            refName={searchTextRef}
                                            value={searchParams["searchText"]}
                                            onChange={handleSearchOnChange}
                                        />
                                    </div>
                                    {searchParams.searchText && (
                                        <div className="flex flex-column col-12">
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        </div>
                                    )}
                                </>
                            )
                        }
                        // if(eachOption.type === "SEARCH_BY"){
                        //     return (
                        //         <>  
                        //             { !eachOption.static ? 
                        //                 <div className="flex justify-content-end p-0 col-12 remove-opt">
                        //                     <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)}></i>
                        //                 </div>
                        //                 :
                        //                 null 
                        //             }
                        //             <div className="flex flex-column col-12">
                        //                 <DropDownField name="searchBy" labelText="Search By" options={eachOption.options} value={searchParams["searchBy"]} onChange={handleSearchOnChange} />
                        //             </div>
                        //             { searchParams.searchBy !== "all" ?
                        //                 <div className="flex flex-column col-12">
                        //                     <TextInputField name="searchText" labelText="Search Text" value={searchParams["searchText"]} onChange={handleSearchOnChange} />
                        //                 </div> : null
                        //             }
                        //         </>
                        //     )
                        // }

                        if (eachOption.type === "DATE") {
                            return (
                                <>
                                   <DateFilter 
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }
                        if (eachOption.type === "SELECT") {
                            return (
                                <>
                                    {!eachOption.static ?
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null
                                    }
                                    {
                                        eachOption.name === "paymentMode" ?
                                            (
                                                <div className="flex flex-column col-12">
                                                    <MultiSelectField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                                </div>
                                            ) :
                                            (
                                                <div className="flex flex-column col-12">
                                                    <DropDownField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                                </div>
                                            )
                                    }
                                </>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }
                    })
                }
                <div className="flex col-12 justify-content-end">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0">
                            <Button label="Search" style={{ flexGrow: 1 }} className="py-2" onClick={handleSearch} />
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3" onClick={(e) => downloadMenu.current.toggle(e)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Search;
